import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { Card, CardBody, Container, Spinner } from "reactstrap"
import withRouter from "Components/Common/withRouter"
import Breadcrumb from "Components/organisms/breadcrumb"
import ActionButton from "Components/atoms/buttons/action-button"
import { navigateBackOr, navigateToManualList, openManualPrint } from "utils/navigator"
import MarkdownViewer from "Components/molecule/markdown-viewer"
import { getManual } from "slices/manuals/thunk"
import { Manual } from "models/manual"

// Route: /manuals/:module/:name, e.g. /manuals/human-resources/employees
const ManualViewPage = (props: any) => {
    const { module, name } = props.router.params
    const slug = module && name ? `${module}/${name}` : ""
    const [manual, setManual] = useState<Manual | null>(null)
    const [isLoading, setIsLoading] = useState(false)

    document.title = `${manual?.title ?? "Manual"} | IbexIQ`

    // Back to wherever the user came from (e.g. the screen's Help button), else the manuals list
    const handleAllManuals = () => navigateToManualList(props.router.navigate)
    const handleBack = () => navigateBackOr(props.router.navigate, handleAllManuals)
    const handlePrint = () => openManualPrint(slug)

    useEffect(() => {
        if (!slug) return
        const load = async () => {
            setIsLoading(true)
            setManual(await getManual(slug))
            setIsLoading(false)
        }
        load()
    }, [slug])

    return (
        <div className="page-content">
            <Container fluid style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                <Breadcrumb
                    title="Manuals"
                    breadcrumbItem={manual?.title ?? "Manual"}
                    actions={
                        <>
                            <ActionButton onClick={handleBack}>Back</ActionButton>
                            <ActionButton onClick={handleAllManuals}>All manuals</ActionButton>
                        </>
                    }
                />

                {isLoading && <Spinner color="primary" />}

                {!isLoading && !manual && (
                    <p className="text-muted">This manual is not available.</p>
                )}

                {!isLoading && manual && (
                    <Card>
                        <CardBody>
                            <div className="manual-toolbar">
                                <div className="manual-toolbar__meta">
                                    <span><i className="bx bx-folder me-1"></i>{manual.module}</span>
                                    {manual.route && (
                                        <Link to={manual.route}><i className="bx bx-link-external me-1"></i>Open screen</Link>
                                    )}
                                    {manual.lastUpdated && (
                                        <span><i className="bx bx-time me-1"></i>Updated {manual.lastUpdated}</span>
                                    )}
                                </div>
                                <button type="button" className="manual-toolbar__print" onClick={handlePrint} title="Print or save as PDF">
                                    <i className="bx bx-printer"></i>
                                    <span>Print</span>
                                </button>
                            </div>
                            <MarkdownViewer content={manual.content} />
                        </CardBody>
                    </Card>
                )}
            </Container>
        </div>
    )
}

export default withRouter(ManualViewPage)
